import { render, staticRenderFns } from "./SmsTemplateEditModal.vue?vue&type=template&id=10c82d67&scoped=true"
import script from "./SmsTemplateEditModal.vue?vue&type=script&lang=js"
export * from "./SmsTemplateEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c82d67",
  null
  
)

export default component.exports